import React from 'react'
import {ConfirmDialog, useConfirmDialog} from '../../hooks/useConfirmDialog'
import {Button} from '@startlibs/components'
import {using} from '@startlibs/utils'
import { useNavigate } from '@startlibs/components';
import _ from 'lodash/fp'
import {isStrEmpty} from '../../utils'
import {FormattedMessage, useIntl} from "react-intl";

export const useConfirmAnswers = (caseRequest, onlyAnswers = false) => {
  const intl = useIntl()
  const navigate = useNavigate()
  // const onlyAnswers = !caseRequest.requestCode

  const confirmNoneVisibleDialog = useConfirmDialog(() =>
    using(!caseRequest.caseInfo.additionalFields.concat(caseRequest.caseInfo.questionsConsultant).length)( hasFields =>
      <ConfirmDialog
        css="max-width:48rem;"
        title={intl.formatMessage({
          defaultMessage: 'Enable fields to proceed',
          description: 'Confirm answers dialog, dialog title'
        })}
        onSuccess={hasFields ? (() => navigate(`/admin/request/${caseRequest.requestCode}/review`)) : undefined}
        confirm={<Button highlight>{hasFields ? intl.formatMessage({
          defaultMessage: "Edit expert review",
          description: "Confirm answers dialog, edit expert review button"
        }): intl.formatMessage({
          defaultMessage:"Edit report",
          description: "Confirm answers dialog, edit report button"
        })}</Button>}
        closeLabel={intl.formatMessage({
          defaultMessage:"Cancel",
          description: "Cancel Button"
        })}
      >
        <p css="margin-top:2rem">
          <FormattedMessage
            defaultMessage={`This report has no available "Questions & answers" and "Additional information".`}
            description="Confirm answers dialog, no visible fields message"
          />
        </p>
        <p><FormattedMessage
          defaultMessage="Please review and enable at least one before proceeding."
          description="Confirm answers dialog, no visible fields instructions"
        /></p>
      </ConfirmDialog>
    ))

  const confirmSomeUnfilledDialog = useConfirmDialog(
    <ConfirmDialog
      css="max-width:48rem;"
      title={onlyAnswers ? intl.formatMessage({
        defaultMessage: 'Please fill in the report answers',
        description: 'Confirm unfilled answers dialog, dialog title'
      }): intl.formatMessage({
        defaultMessage:'Please fill in the report fields',
        description: 'Confirm unfilled fields dialog, dialog title'
      })}
      onSuccess={() => navigate(onlyAnswers ? `/expert/case/${caseRequest.requestId}/questions` : `/admin/request/${caseRequest.requestCode}/review`)}
      confirm={<Button highlight><FormattedMessage
        defaultMessage="Edit expert review"
        description="Confirm unfilled answers dialog, edit expert review button"
      /></Button>}
      closeLabel={intl.formatMessage({
        defaultMessage:"Cancel",
        description: "Cancel Button"
      })}
    >
      <p css="margin-top:2rem">
        <FormattedMessage
          defaultMessage="Some of your report {onlyAnswers, select, true {answers} other {fields}} are left empty. Please complete {onlyAnswers, select, true {those answers} other {or hide these fields}} before proceeding."
          description="Confirm unfilled answers dialog, unfilled answers message"
          values={{onlyAnswers}}
        />
      </p>
    </ConfirmDialog>)


  return () => {

    const additionalFields = caseRequest?.reportData?.reportLayout?.additionalFields
      ? _.filter(({hide}) => !hide,caseRequest.caseInfo.additionalFields).map(({title,content})=> ({label:title,value:content}))
      : []

    const questionsAndAnswers = caseRequest?.reportData?.reportLayout?.questionsConsultant
      ? _.filter(({hide})=>!hide,caseRequest.caseInfo.questionsConsultant).map(({question,answer})=> ({label:question,value:answer}))
      : []

    const visibleAnswers = onlyAnswers
      ? caseRequest.caseInfo.questionsConsultant.map(({question,answer})=> ({label:question,value:answer}))
      : additionalFields.concat(questionsAndAnswers)

    if (!visibleAnswers.length) {
      confirmNoneVisibleDialog()
      return new Promise(() => {})
    }

    const hasEmptyAnswers = visibleAnswers.find(({label,value})=> isStrEmpty(label) || isStrEmpty(value))
    if (hasEmptyAnswers) {
      confirmSomeUnfilledDialog()
      return new Promise(() => {})
    }
    return Promise.resolve()
  }

}
